import React from "react";
import ConsultationReviewHistory from "../../../Components/Reviews/ConsultationReviewHistory";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHistory } from "@fortawesome/free-solid-svg-icons";
import { useTenantContent } from "../../../Context/TenantContentContext";
import Loader from "../../../Components/Core/Loader";

const ChatHistory = (props) => {
  const { content, loading } = useTenantContent();
  if (loading || !content) {
    return <Loader />;
  }

  return (
    <div className="section-card">
      <div className="section-header">
        <div className="section-icon">
          <FontAwesomeIcon icon={faHistory} />
        </div>
        <h2 className="section-title">تاریخچه مشاوره ها</h2>
      </div>

      {props.historySessions.length > 0 ? (
        <ConsultationReviewHistory sessions={props.historySessions} handleJoinChat={props.handleJoinChat} avatar={content.doctorAvatarUrl} />
      ) : (
        <div className="empty-state">
          <div className="empty-state-icon">
            <FontAwesomeIcon icon={faHistory} />
          </div>
          <h3>هیچ مشاوره قبلی یافت نشد</h3>
          <p>
            پس از تکمیل اولین جلسه مشاوره، تاریخچه آن در اینجا نمایش داده خواهد
            شد.
          </p>
        </div>
      )}
    </div>
  );
};

export default ChatHistory;
